var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { JwksValidationHandler } from 'angular-oauth2-oidc';
import { OAuthService } from 'angular-oauth2-oidc';
import { UserManager } from 'oidc-client';
/* Left for reference
export const authConfig: AuthConfig = {
    // Url of the Identity Provider
    issuer: 'https://login.microsoftonline.com/6ea74a44-2098-4a46-b4ce-a9e1ffda6fa8/v2.0/',
    tokenEndpoint: 'https://login.microsoftonline.com/conquexenps.onmicrosoft.com/oauth2/v2.0/token?p=b2c_1_siupin',
    logoutUrl: 'https://login.microsoftonline.com/conquexenps.onmicrosoft.com/oauth2/v2.0/logout?p=b2c_1_siupin',
    // URL of the SPA to redirect the user to after login
    redirectUri: window.location.origin + '/APPlaybook/',
    // The SPA's id. The SPA is registerd with this id at the auth-server
    clientId: '1f3eff9f-c174-4bf8-abe5-20462835d2c1',
    // set the scope for the permissions the client should request
    // The first three are defined by OIDC. The 4th is a usecase-specific one
    scope: 'openid https://conquexenps.onmicrosoft.com/enpslocal/user_impersonation https://conquexenps.onmicrosoft.com/enpslocal/read',
    strictDiscoveryDocumentValidation: false,
    loginUrl: 'https://login.microsoftonline.com/conquexenps.onmicrosoft.com/oauth2/v2.0/authorize?p=b2c_1_siupin',
    requestAccessToken: true,
    responseType: "id_token"
}*/
/*
export const authConfig: AuthConfig = {
    // Url of the Identity Provider
    issuer: 'https://graph.microsoft.com/v1.0/me',
    tokenEndpoint: 'https://login.microsoftonline.com/common/oauth2/v2.0/token',
    // URL of the SPA to redirect the user to after login
    redirectUri: window.location.origin + '/APPlaybook/',
    // The SPA's id. The SPA is registerd with this id at the auth-server
    clientId: 'f84aa838-cef4-4167-873d-42573c494736',
    // set the scope for the permissions the client should request
    // The first three are defined by OIDC. The 4th is a usecase-specific one
    scope: 'https://graph.microsoft.com/user.read openid profile',
    strictDiscoveryDocumentValidation: false,
    loginUrl: 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize',
    requestAccessToken: true,
    //responseType: "id_token"
}

export const facebookAuthConfig: AuthConfig = {
    issuer: 'https://graph.facebook.com/me',
    loginUrl: 'https://www.facebook.com/dialog/oauth',
    tokenEndpoint: 'https://graph.facebook.com/oauth/access_token',
    redirectUri: window.location.origin + '/' + virtualDirectory + '/',
    clientId: '192287021412038',
    scope: "email",
    strictDiscoveryDocumentValidation: false,
    showDebugInformation: true,
    sessionChecksEnabled: true,
    oidc: false,
    requestAccessToken: true,
    responseType: "id_token"
}
*/
export var oktaAuthConfig = {
    issuer: '',
    tokenEndpoint: '',
    redirectUri: window.location.origin + '/' + virtualDirectory + '/',
    clientId: '',
    scope: 'openid email',
    strictDiscoveryDocumentValidation: false,
    loginUrl: '',
    requestAccessToken: false,
    responseType: "id_token"
};
export var microsoftAuthConfig = {
    issuer: 'https://graph.microsoft.com/v1.0/me',
    tokenEndpoint: 'https://login.microsoftonline.com/common/oauth2/v2.0/token',
    redirectUri: window.location.origin + '/' + virtualDirectory + '/',
    clientId: '',
    scope: 'User.Read email profile',
    strictDiscoveryDocumentValidation: false,
    loginUrl: 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize',
    requestAccessToken: true,
    responseType: "id_token"
};
export var googleAuthConfig = {
    issuer: 'https://accounts.google.com',
    redirectUri: window.location.origin + '/' + virtualDirectory + '/',
    logoutUrl: window.location.origin + '/' + virtualDirectory + '/',
    clientId: '',
    scope: 'openid profile email',
    strictDiscoveryDocumentValidation: false,
    showDebugInformation: true,
    sessionChecksEnabled: true
};
export var oneLoginAuthConfig = {
    authority: null,
    client_id: null,
    redirect_uri: window.location.origin + '/' + virtualDirectory,
    post_logout_redirect_uri: window.location.origin + '/' + virtualDirectory,
    response_type: 'id_token token',
    scope: 'openid profile',
    filterProtocolClaims: true,
    loadUserInfo: true,
    automaticSilentRenew: true,
    silent_redirect_uri: window.location.origin + '/' + virtualDirectory
};
var SSOService = /** @class */ (function () {
    function SSOService(oauthService) {
        this.oauthService = oauthService;
        this.oneLoginUserManager = null;
        this.googleId = 'GOOGLE';
        this.microsoftId = 'MICROSOFT';
        this.oktaId = 'OKTA';
        this.oneLoginId = 'ONELOGIN';
        this.authConfig = null;
        this.provider = '';
        this.ssoSettings = null;
        this.providerId = null;
    }
    SSOService.prototype.configureWithNewConfigApi = function () {
        return __awaiter(this, void 0, void 0, function () {
            var i, providerId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.ssoSettings) return [3 /*break*/, 2];
                        for (i = 0; i < this.ssoSettings.length; i++) {
                            if (this.ssoSettings[i]["ID"] == "GOOGLE")
                                googleAuthConfig.clientId = this.ssoSettings[i]["ClientId"];
                            if (this.ssoSettings[i]["ID"] == "MICROSOFT LIVE" || this.ssoSettings[i]["ID"] == "MICROSOFTLIVE")
                                microsoftAuthConfig.clientId = this.ssoSettings[i]["ClientId"];
                            if (this.ssoSettings[i]["ID"] == "MICROSOFT AZURE" || this.ssoSettings[i]["ID"] == "MICROSOFTAZURE")
                                microsoftAuthConfig.clientId = this.ssoSettings[i]["ClientId"];
                            if (this.ssoSettings[i]["ID"] == "OKTA") {
                                oktaAuthConfig.clientId = this.ssoSettings[i]["ClientId"];
                                oktaAuthConfig.issuer = this.ssoSettings[i]["BaseUrl"];
                                oktaAuthConfig.tokenEndpoint = oktaAuthConfig.issuer + '/oauth2/v1/token';
                                oktaAuthConfig.loginUrl = oktaAuthConfig.issuer + '/oauth2/v1/authorize';
                            }
                            if (this.ssoSettings[i]["ID"] == "ONELOGIN") {
                                oneLoginAuthConfig.client_id = this.ssoSettings[i]["ClientId"];
                                oneLoginAuthConfig.authority = this.ssoSettings[i]["BaseUrl"] + '/oidc/2';
                                this.oneLoginUserManager = new UserManager(oneLoginAuthConfig);
                            }
                        }
                        providerId = localStorage.getItem("providerName");
                        this.providerId = providerId;
                        if (providerId == this.googleId)
                            this.authConfig = googleAuthConfig;
                        if (providerId.indexOf(this.microsoftId) > -1)
                            this.authConfig = microsoftAuthConfig;
                        if (providerId == this.oktaId)
                            this.authConfig = oktaAuthConfig;
                        this.oauthService.configure(this.authConfig);
                        this.oauthService.tokenValidationHandler = new JwksValidationHandler();
                        this.oauthService.setStorage(sessionStorage);
                        if (!(providerId == this.googleId)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.oauthService.loadDiscoveryDocumentAndTryLogin()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    SSOService.prototype.authenticate = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.configureWithNewConfigApi()];
                    case 1:
                        _a.sent();
                        if (this.providerId == this.oneLoginId) {
                            this.oneLoginUserManager.signinRedirect();
                        }
                        else {
                            this.oauthService.initImplicitFlow();
                        }
                        return [2 /*return*/, null];
                }
            });
        });
    };
    return SSOService;
}());
export { SSOService };



// WEBPACK FOOTER //
// ./src/app/providers/authentication/sso/sso.service.ts.pre-build-optimizer.js